import { Component, input, computed, effect, signal, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { HisOption } from '../../../../genericsearch/model/his-option';
import { Observable } from 'rxjs';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';

type SelectionOption = {
    key: string;
    label: string;
    name: string;
    value: string;
    sortorder: number;
}

type SelectionSetting = {
    value: string[];
    defaultValue: string;
    label: string;
    helptext?: string;
    required: boolean;
    readonly: boolean;
    options: SelectionOption[];
    name: string;
}

@Component( {
    selector: 'his-select-many-job-setting',
    templateUrl: './his-select-many-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
} )
export class HisSelectManyJobSettingComponent implements OnInit {
    setting = input.required<SelectionSetting>();
    private allOptions = computed<HisOption[]>( () => this.setting().options?.map( option => new HisOption( option.label, option.key ) ) );
    protected selectedItems = signal<HisOption[]>( [] ); //XXX: replace with linkedSignal when available in stable API
    private readonly allOptions$ = toObservable( this.allOptions );
    private baseGlobalService = inject( HisBaseGlobalsService );

    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    } );
    
    constructor() {
        // Init selection in ui with the default value if any is present
        //XXX: replace with linkedSignal when available in stable API
        effect( () => this.setting().value?.map( value => this.allOptions().find( option => option.id === value ) ) || [] );

        // sync selection from multiselect with the setting value
        effect( () => {
            this.setting().value = this.allOptions().filter( option => this.selectedItems().some( selected => selected.id === option.id && selected.label === option.label ) )
                .filter( option => this.setting().options.some( opt => opt.label === option.label && opt.key === option.id ) )
                .map( option => this.setting().options.find( opt => opt.label === option.label && opt.key === option.id ) )
                .map( option => option.value ) || undefined;
        } );
    }

    ngOnInit(): void {
        this.selectedItems.set( this.allOptions().filter( option => this.setting().value?.some( value => value === option.id ) ) );
    }

    protected getAllOptions(): Observable<HisOption[]> {
        return this.allOptions$;
    }
}
